import { render, staticRenderFns } from "./HumanBodyFemaleFrontMuscles.vue?vue&type=template&id=22a0b6d6"
import script from "./HumanBodyFemaleFrontMuscles.vue?vue&type=script&lang=js"
export * from "./HumanBodyFemaleFrontMuscles.vue?vue&type=script&lang=js"
import style0 from "./HumanBodyFemaleFrontMuscles.vue?vue&type=style&index=0&id=22a0b6d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports